define('v3/Common/ViewModels/Navigation/ActiveClassInDevicePoolLinkViewModel',[
	'knockout',
	'v3/Common/Services/Backend/activeClassInDevicePoolBackend',
	'v3/Common/Services/Frontend/Frontend.Service',
	'v3/FromV2/utils'
], function (ko, backend, frontend) {
	function ActiveClassInDevicePoolLinkViewModel () {
		var self = this;

		self.isLoading = ko.observable(true);
		self.isSaving = ko.observable(false);

		self.isPoolDevicesEnabled = ko.observable(false);
		self.isPoolDevicesForActiveClass = ko.observable(false);
		self.activeClassNameInDevicePoolConfirmation = ko.observable('');

		self.canReset = ko.computed(function () {
			return (self.isPoolDevicesEnabled() === false ||
				self.isPoolDevicesForActiveClass() ||
				self.isLoading()) === false;
		});

		self.cancel = function () {
			self.modal.close();
		};

		self.ok = function () {
			self.isSaving(true);
			backend.setActiveClass()
				.done(function (data) {
					if (data && !data.success) {
						frontend.notification.ajax.error(data.message || Strings.Error);
					}

					self.modal.close();
				})
				.always(function () { self.isSaving(false); });
		};

		backend.getDevicesInfo()
			.done(function (data) {
				self.isPoolDevicesEnabled(data.isPoolDevicesEnabled);
				self.isPoolDevicesForActiveClass(data.isPoolDevicesForActiveClass);
				self.activeClassNameInDevicePoolConfirmation(
					Strings.SetActiveClassInDevicePoolConfirmation.formatEncodeArguments(data.activeClassNameInDevicePool));
			})
			.always(function () {
				self.isLoading(false);
			});
	}

	return ActiveClassInDevicePoolLinkViewModel;
});
